import React from "react";
import content from "../data/results/2017content.json";
import resultData from "../data/2017data.json";
import ResultsPage from "./ResultsPage";

const Results2017 = () => <ResultsPage content={content} resultData={resultData} />;

export default Results2017;
